<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <Products></Products>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Products from "../../components/product/Products.vue";

export default {
    components: {
        Products
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
